import React, {Fragment, useEffect, useState} from "react";

import {
    defaultTableHeaderStyles,
    defaultPaginationOptions,
    customHeaderStyle,
    defaultTopRightCellStyle
} from "../../Tables/BaseTableComponents";

import PassportTable, {xlateBootstrapTableColumns} from "../../Tables/PassportTable";
import SpinnerDiv from "../../ui/ReactSpinnerDiv";
import {getDataFromResponse} from "../../DataFunctions/BaseDataFns";
import {getSchoolAttendanceStats} from "../../DataFunctions/StatisticsDataFns";

const AttendanceSummaryTable = (props) => {

    const [data, setData] = useState({ isLoading: true, data: [] });

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        if(props.school_id !== undefined)
        {
            getSchoolAttendanceStats(props.school_id, (response) =>
            {
                setData({isLoading: false, data: getDataFromResponse(response)});
            });
        }
    };

    const headerStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        group_name: {width: '15vw' },
        today: {width: '5vw' },
        week: {width: '5vw' },
        term: {width: '5vw'},
        year: {width: '5vw' }
    });

    const nameRenderer = (cell, row, rowIndex, formatExtraData) => {
        return (
            <Fragment>
                { row.group_name === 'All Classes' && <b><span>{row.group_name}</span></b>}
                { row.group_name !== 'All Classes' && <span>{row.group_name}</span>}
            </Fragment>
        );
    };

    const getColumns = () => {
        const columns = [
            {
                dataField: 'group_name',
                text: "",
                search: true,
                sort: true,
                headerStyle: headerStyle,
                formatter: nameRenderer
            },
            {
                dataField: 'today',
                text: "Today",
                search: true,
                sort: true,
                headerStyle: headerStyle,
            },
            {
                dataField: 'week',
                text: "This Week",
                search: true,
                sort: true,
                headerStyle: headerStyle,
            },
            {
                dataField: 'term',
                text: "This Term",
                search: true,
                sort: true,
                headerStyle: headerStyle,
            },
            {
                dataField: 'year',
                text: "This Year",
                search: true,
                sort: true,
                headerStyle: headerStyle,
            }
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns( getColumns()) ;
    const columns = React.useMemo(() => translations, []) ;

    const tableContent = () =>
    {
        return (
            <Fragment>
                <PassportTable data={data.data} isLoading={data.isLoading} columns={columns}
                               pagination={defaultPaginationOptions}/>
            </Fragment>
        )
    }

    return data.isLoading === true ? <SpinnerDiv /> : tableContent();
};

export default AttendanceSummaryTable;
